import {getId} from 'apis/model/base'
import React, {useContext} from 'react'
import {RelatedCodiReferences} from 'views/Document/components/Codi/CodiDocumentSource'
import CodiContext from './CodiContext'

const CodiRelatedCodi = ({style, className, ...props}) => {
  const {item} = useContext(CodiContext)
  return (
    <RelatedCodiReferences
      style={style}
      className={className}
      codi_id={getId(item)}
      {...props}
    />
  )
}

export default CodiRelatedCodi
